import React from "react";
import PageStatus from "components/ui/PageStatus";
import { StatusCard, StatusTitle, StatusBody } from "components/ui/StatusCard";

export function UIDErrorCard() {
  return (
    <PageStatus>
      <StatusCard>
        <StatusTitle>
          <h2>Unrecognized Login</h2>
        </StatusTitle>
        <StatusBody>
          <p style={{ marginTop: 0 }}>
            Sorry, CalCentral currently does not recognize your login. You may
            log out and try again, or contact our{" "}
            <a href="https://sis.berkeley.edu/help/calcentral-support">
              support team
            </a>
            .
          </p>

          <p>
            If you are a current applicant, you may view your application or
            admission status at{" "}
            <a href="http://admissions.berkeley.edu/myapplicationportal">
              MAP@Berkeley
            </a>
            .
          </p>
        </StatusBody>
      </StatusCard>
    </PageStatus>
  );
}
